{
  "en": {
    "activemodel": {
      "attributes": {
        "share_content": {
          "body": "Your message",
          "from_address": "Your email",
          "to_address": "Recipient’s email"
        }
      }
    },
    "activerecord": {
      "attributes": {
        "agent_profile": {
          "agent_location": "Agent Location",
          "services": "Specialties",
          "supported_languages": "Supported Languages"
        },
        "enquiry": {
          "body": "Please write your message",
          "body_default": {
            "rent": "Hello,\n\nI would like to schedule a viewing of this Property for Rent.  Please can you call or email me as soon as possible.\n\nBest Regards.\n",
            "sale": "Hello,\n\nI would like to schedule a viewing of this Property for Sale.  Please can you call or email me as soon as possible.\n\nBest Regards.\n"
          },
          "country_of_residence": "Where do you live?",
          "email": "Email",
          "name": "Name",
          "phone": "Phone",
          "prefecture": "Where are you searching for properties?",
          "verification_code": "",
          "verification_code2": "Verification code"
        },
        "property": {
          "beds": "Beds",
          "price": "Price",
          "property_location": "Prefecture",
          "property_type": "Property Type"
        }
      },
      "enums": {
        "agent_profile": {
          "locations": {
            "1": "Hokkaido",
            "10": "Gunma",
            "11": "Saitama",
            "12": "Chiba",
            "13": "Tokyo",
            "14": "Yokohama/Kanagawa",
            "15": "Niigata",
            "16": "Toyama",
            "17": "Kanazawa/Ishikawa",
            "18": "Fukui",
            "19": "Yamanashi",
            "2": "Aomori",
            "20": "Nagano",
            "21": "Gifu",
            "22": "Shizuoka",
            "23": "Nagoya/Aichi",
            "24": "Mie",
            "25": "Shiga",
            "26": "Kyoto",
            "27": "Osaka",
            "28": "Kobe/Hyogo",
            "29": "Nara",
            "3": "Iwate",
            "30": "Wakayama",
            "31": "Tottori",
            "32": "Shimane",
            "33": "Okayama",
            "34": "Hiroshima",
            "35": "Yamaguchi",
            "36": "Tokushima",
            "37": "Kagawa",
            "38": "Ehime",
            "39": "Kochi",
            "4": "Sendai/Miyagi",
            "40": "Fukuoka",
            "41": "Saga",
            "42": "Nagasaki",
            "43": "Kumamoto",
            "44": "Oita",
            "45": "Miyazaki",
            "46": "Kagoshima",
            "47": "Okinawa",
            "5": "Akita",
            "6": "Yamagata",
            "7": "Fukushima",
            "8": "Ibaraki",
            "9": "Tochigi",
            "99": "All over Japan"
          },
          "prefectures": {
            "-1": "All over Japan",
            "1": "Hokkaido",
            "10": "Gunma",
            "11": "Saitama",
            "12": "Chiba",
            "13": "Tokyo",
            "14": "Kanagawa",
            "15": "Niigata",
            "16": "Toyama",
            "17": "Ishikawa",
            "18": "Fukui",
            "19": "Yamanashi",
            "2": "Aomori",
            "20": "Nagano",
            "21": "Gifu",
            "22": "Shizuoka",
            "23": "Aichi",
            "24": "Mie",
            "25": "Shiga",
            "26": "Kyoto",
            "27": "Osaka",
            "28": "Hyogo",
            "29": "Nara",
            "3": "Iwate",
            "30": "Wakayama",
            "31": "Tottori",
            "32": "Shimane",
            "33": "Okayama",
            "34": "Hiroshima",
            "35": "Yamaguchi",
            "36": "Tokushima",
            "37": "Kagawa",
            "38": "Ehime",
            "39": "Kochi",
            "4": "Miyagi",
            "40": "Fukuoka",
            "41": "Saga",
            "42": "Nagasaki",
            "43": "Kumamoto",
            "44": "Oita",
            "45": "Miyazaki",
            "46": "Kagoshima",
            "47": "Okinawa",
            "5": "Akita",
            "6": "Yamagata",
            "7": "Fukushima",
            "8": "Ibaraki",
            "9": "Tochigi"
          },
          "services": {
            "1": "For Sale",
            "16": "Judicial Scrivener",
            "2": "For Rent",
            "4": "Property Management",
            "8": "Renovation"
          }
        },
        "property": {
          "available_from": {
            "1": "Now",
            "2": "Ask",
            "3": "Specified Date"
          },
          "available_from_period": {
            "1": "Early ",
            "2": "Mid-",
            "3": "Late "
          },
          "bathrooms": {
            "0.0": 0,
            "0.5": 0.5,
            "1.0": 1,
            "1.5": 1.5,
            "2.0": 2,
            "2.5": 2.5,
            "3.0": 3,
            "3.5": 3.5,
            "4.0": "4+"
          },
          "bedrooms": {
            "-1": "STUDIO",
            "1": "1 Bed",
            "101": "Private Room",
            "102": "Shared Room",
            "2": "2 Beds",
            "201": "Whole Building",
            "3": "3 Beds",
            "4": "4 Beds",
            "5": "5 Beds",
            "6": "6+ Beds"
          },
          "city_planning": {
            "1": "Urbanization promotion areas",
            "2": "Urbanization control areas",
            "3": "Non-classified city planning areas",
            "4": "Non-city planning areas"
          },
          "connecting_road_direction1": {
            "1": "North",
            "2": "Northeast",
            "3": "East",
            "4": "Southeast",
            "5": "South",
            "6": "Southwest",
            "7": "West",
            "8": "Northwest"
          },
          "connecting_road_direction2": {
            "1": "North",
            "2": "Northeast",
            "3": "East",
            "4": "Southeast",
            "5": "South",
            "6": "Southwest",
            "7": "West",
            "8": "Northwest"
          },
          "connecting_road_direction3": {
            "1": "North",
            "2": "Northeast",
            "3": "East",
            "4": "Southeast",
            "5": "South",
            "6": "Southwest",
            "7": "West",
            "8": "Northwest"
          },
          "connecting_road_direction4": {
            "1": "North",
            "2": "Northeast",
            "3": "East",
            "4": "Southeast",
            "5": "South",
            "6": "Southwest",
            "7": "West",
            "8": "Northwest"
          },
          "connecting_road_kind1": {
            "1": "Public roads",
            "2": "Private roads"
          },
          "connecting_road_kind2": {
            "1": "Public roads",
            "2": "Private roads"
          },
          "connecting_road_kind3": {
            "1": "Public roads",
            "2": "Private roads"
          },
          "connecting_road_kind4": {
            "1": "Public roads",
            "2": "Private roads"
          },
          "construction_status": {
            "2": "Under Construction",
            "3": "New Construction"
          },
          "guarantee_company": {
            "1": "Required to use",
            "2": "Not Required",
            "3": "Usable"
          },
          "insurance": {
            "1": "Necessary",
            "2": "Unnecessary"
          },
          "land_category": {
            "1": "residential areas",
            "2": "rice fields",
            "3": "crop fields",
            "4": "mountains and forests",
            "5": "hybrid areas",
            "6": "others"
          },
          "land_law_notification": {
            "1": "Notification required",
            "2": "No notification required",
            "3": "Notification in progress"
          },
          "land_rights": {
            "1": "Freehold",
            "2": "Leasehold",
            "3": "Leasehold",
            "4": "Leasehold",
            "5": "Leasehold"
          },
          "land_use_zone": {
            "1": "Category 1 low-rise exclusive residential districts",
            "10": "Quasi-industrial districts",
            "11": "Industrial districts",
            "12": "Exclusive industrial districts",
            "13": "Non specified",
            "14": "Countryside Residential Zone",
            "2": "Category 2 low-rise exclusive residential districts",
            "3": "Category 1 medium-to-high-rise exclusive residential districts",
            "4": "Category 2 medium-to-high-rise exclusive residential districts",
            "5": "Category 1 residential districts",
            "6": "Category 2 residential districts",
            "7": "Quasi-residential districts",
            "8": "Neighborhood commercial districts",
            "9": "Commercial districts"
          },
          "location": {
            "1": "Hokkaido",
            "10": "Gunma",
            "11": "Saitama",
            "12": "Chiba",
            "13": "Tokyo",
            "14": "Yokohama/Kanagawa",
            "15": "Niigata",
            "16": "Toyama",
            "17": "Kanazawa/Ishikawa",
            "18": "Fukui",
            "19": "Yamanashi",
            "2": "Aomori",
            "20": "Nagano",
            "21": "Gifu",
            "22": "Shizuoka",
            "23": "Nagoya/Aichi",
            "24": "Mie",
            "25": "Shiga",
            "26": "Kyoto",
            "27": "Osaka",
            "28": "Kobe/Hyogo",
            "29": "Nara",
            "3": "Iwate",
            "30": "Wakayama",
            "31": "Tottori",
            "32": "Shimane",
            "33": "Okayama",
            "34": "Hiroshima",
            "35": "Yamaguchi",
            "36": "Tokushima",
            "37": "Kagawa",
            "38": "Ehime",
            "39": "Kochi",
            "4": "Sendai/Miyagi",
            "40": "Fukuoka",
            "41": "Saga",
            "42": "Nagasaki",
            "43": "Kumamoto",
            "44": "Oita",
            "45": "Miyazaki",
            "46": "Kagoshima",
            "47": "Okinawa",
            "5": "Akita",
            "6": "Yamagata",
            "7": "Fukushima",
            "8": "Ibaraki",
            "9": "Tochigi",
            "99": "All over Japan"
          },
          "main_aspect": {
            "1": "North",
            "2": "Northeast",
            "3": "East",
            "4": "Southeast",
            "5": "South",
            "6": "Southwest",
            "7": "West",
            "8": "Northwest"
          },
          "management": {
            "1": "Self Management",
            "2": "Partial Consignment",
            "3": "Full Consignment"
          },
          "management_method": {
            "1": "Full-time",
            "2": "Daily service",
            "3": "Patrol",
            "4": "None",
            "5": "Part-time"
          },
          "parking_space_type": {
            "1": "Available",
            "2": "None",
            "3": "None"
          },
          "prefecture": {
            "-1": "All over Japan",
            "1": "Hokkaido",
            "10": "Gunma",
            "11": "Saitama",
            "12": "Chiba",
            "13": "Tokyo",
            "14": "Kanagawa",
            "15": "Niigata",
            "16": "Toyama",
            "17": "Ishikawa",
            "18": "Fukui",
            "19": "Yamanashi",
            "2": "Aomori",
            "20": "Nagano",
            "21": "Gifu",
            "22": "Shizuoka",
            "23": "Aichi",
            "24": "Mie",
            "25": "Shiga",
            "26": "Kyoto",
            "27": "Osaka",
            "28": "Hyogo",
            "29": "Nara",
            "3": "Iwate",
            "30": "Wakayama",
            "31": "Tottori",
            "32": "Shimane",
            "33": "Okayama",
            "34": "Hiroshima",
            "35": "Yamaguchi",
            "36": "Tokushima",
            "37": "Kagawa",
            "38": "Ehime",
            "39": "Kochi",
            "4": "Miyagi",
            "40": "Fukuoka",
            "41": "Saga",
            "42": "Nagasaki",
            "43": "Kumamoto",
            "44": "Oita",
            "45": "Miyazaki",
            "46": "Kagoshima",
            "47": "Okinawa",
            "5": "Akita",
            "6": "Yamagata",
            "7": "Fukushima",
            "8": "Ibaraki",
            "9": "Tochigi"
          },
          "property_type": {
            "-1": "All Property Types",
            "1": "Apartment",
            "10": "Commercial Building",
            "11": "Hotel / Ryokan",
            "12": "Town House",
            "2": "House",
            "3": "Land",
            "4": "Short Term",
            "5": "Share House",
            "6": "Apartment Building",
            "7": "Office Space",
            "8": "Retail Space",
            "9": "Office and Retail Space"
          },
          "purpose": {
            "1": "For Residence",
            "2": "For Investment"
          },
          "status": {
            "1": "Vacant",
            "10": "In use",
            "2": "Occupied",
            "3": "Under construction",
            "4": "Vacant land",
            "5": "Old house exists",
            "6": "Tenanted",
            "7": "Partially tenanted",
            "8": "Fully tenanted",
            "9": "Never occupied"
          },
          "structure": {
            "1": "Wooden Structure",
            "10": "Autoclaved Lightweight Concrete",
            "11": "Reinforced Concrete Block",
            "12": "Concrete Filled Steel Tube",
            "13": "Wooden Structure・Other",
            "14": "Reinforced Concrete・Other",
            "15": "Steel Reinforced Concrete・Other",
            "16": "Steel Frame Structure・Other",
            "17": "Concrete Block Structure・Other",
            "18": "Precast Concrete・Other",
            "19": "H-Shaped Steel Precast Concrete・Other",
            "2": "Reinforced Concrete",
            "20": "Light Gauge Steel・Other",
            "21": "Autoclaved Lightweight Concrete・Other",
            "22": "Reinforced Concrete Block・Other",
            "23": "Concrete Filled Steel Tube・Other",
            "3": "Steel Reinforced Concrete",
            "4": "Steel Frame Structure",
            "5": "Concrete Block Structure",
            "6": "Precast Concrete",
            "7": "H-Shaped Steel Precast Concrete",
            "8": "Other",
            "9": "Light Gauge Steel"
          },
          "type": {
            "rent": "Rent",
            "sale": "Buy"
          },
          "type_of_transaction": {
            "1": "Property Owner",
            "2": "Seller Direct",
            "3": "Exclusive Right-to-Sell Listing Agreement",
            "4": "Exclusive Agency Listing Agreement",
            "5": "Open Listing Agreement",
            "6": "Brokerage",
            "7": "Other"
          }
        }
      }
    },
    "agencies": {
      "index": {
        "js": {
          "empty": "Sorry, we were unable to find any agents matching your search criteria.<br>Please try searching agents with different criteria."
        }
      }
    },
    "bookmark_properties": {
      "index": {
        "js": {
          "empty": "You haven't saved any property yet"
        }
      }
    },
    "c": {
      "bookmarked_properties": "Favorites",
      "buy": "Buy",
      "city_ward": "City / Ward",
      "featured": "Featured",
      "for_rent": {
        "other": "For Rent"
      },
      "for_sale": {
        "other": "For Sale"
      },
      "japan_blog": "Japan Property Blog",
      "login": "Log In",
      "logout": "Logout",
      "make_enquiry": "Make Inquiry",
      "max_price": "Max Price (JPY)",
      "name": "Name",
      "no_max_price": "No max price",
      "no_max_price_short": "No max",
      "no_min_price_short": "No min",
      "phone": "Phone",
      "please_write_your_message": "Please write your message*",
      "property_agencies_and_sellers": "Real Estate Agents & Companies in %{location}",
      "provided_by": "Listing provided by",
      "read_more": "Read More",
      "rent": "Rent",
      "sale": "Sale",
      "search": "Search",
      "search_box": {
        "home_type": "Home Type",
        "maximum": "Maximum",
        "minimum": "Minimum",
        "price_range": "Price Range"
      },
      "search_by": {
        "fewer_filters": "Close",
        "more_filters": "Other Search",
        "prefecture": "Prefecture",
        "properties_count_surfix": "%{content} (%{count})",
        "property_type": "Property Type",
        "search_by_city": "Search by City",
        "search_by_train_station": "Search by Train Station",
        "search_for_homes_by_city": "Serch for homes by city"
      },
      "search_for_properties": "Search for Properties",
      "sign_up": "Sign Up",
      "type_of_home": "Type of Home",
      "yen": "JPY"
    },
    "devise": {
      "registrations": {
        "confirm_destroy": {
          "js": {
            "confirmation": "Are you sure you want to permanently delete Account ?"
          }
        }
      }
    },
    "enquiries": {
      "show": {
        "js": {
          "caution": "By clicking the Submit button, you agree that RETA Inc. may contact you by phone, email, or other means regarding your inquiry. These communications may involve the use of automated systems. You also agree to our <a href='/en/privacy-policy'>Privacy Policy</a> regarding the handling of your personal information.",
          "contact_agent": "Contact agent",
          "submit": "Send Inquiry"
        }
      }
    },
    "properties": {
      "city": {
        "js": {
          "please_select_cities": "Please select cities",
          "select_prefecture": "Select Prefecture",
          "title": "Search for Property by City"
        }
      },
      "index": {
        "js": {
          "cities": "Cities",
          "empty": "Sorry, we were unable to find any properties matching your search criteria.<br>Please try searching properties with different criteria.",
          "features": "Features",
          "over_selected": "You can inquire about up to 5 properties at a time. Please complete your inquiry.",
          "relevant_listings": "Relevant listings",
          "sort": "Sort: ",
          "sort_by_gross_yield_higher": "Gross Yield (High to Low)",
          "sort_by_home_age_higher": "Home Age (Newest)",
          "sort_by_home_size_higher": "Home Size (Largest)",
          "sort_by_land_size_higher": "Land Size (Largest)",
          "sort_by_price_higher": "Price (High to Low)",
          "sort_by_price_lower": "Price (Low to High)",
          "sort_by_purpose": "For Investment"
        }
      },
      "show": {
        "js": {
          "share": {
            "placeholder_message": "Check out this home I found on Japan-Property.",
            "send_email": "Send email",
            "sent": "Successfully shared this property"
          }
        }
      },
      "train": {
        "js": {
          "please_select_stations": "Please select stations",
          "please_select_train_lines": "Please select train lines",
          "select_prefecture": "Select Prefecture",
          "select_stations": "Select Stations",
          "title": "Search for Property by Train Station"
        }
      }
    },
    "shared": {
      "header": {
        "js": {
          "delete_account": "Delete Account",
          "favorite": "Favorite",
          "myaccount": "My Account"
        },
        "language": "Language"
      }
    },
    "welcome": {
      "index": {
        "js": {
          "area_guides": "Area Guides",
          "buying_guide": "Buying Guide",
          "catch_copy": "Find your ideal home <br class='u-sp'>in Japan",
          "explore_top_neighborhoods": "Explore Top Neighborhoods",
          "featured_agencies_and_sellers": "Featured Agencies and Sellers",
          "featured_properties_for_rent": "Featured Properties for Rent",
          "featured_properties_for_sale": "Featured Properties for Sale",
          "find_more_agents": "Find More Agents",
          "footer_description": "Japan-property.jp has one of the leading property portal websites in Japan, foreign buyers and investors to find property from the country's top real estate agents and property developers. The site’s search tools empower customers to easily 'move online' becoming the one stop shop to buy, sell or rent real estate.<br>We will fully support you in purchasing real estate made for investment, as well as securing rental properties such as houses or apartments at popular locations in Japan such as Tokyo, Yokohama, Osaka and Kyoto.",
          "loan_guide": "Loan Guide",
          "newest_listings_for_rent": "Newest Listings for Rent",
          "newest_listings_for_sale": "Newest Listings for Sale",
          "renting_guide": "Renting Guide",
          "view_more_properties": "View More Properties"
        }
      }
    }
  },
  "ja": {
    "activerecord": {
      "attributes": {
        "agent_profile": {
          "services": "提供サービス"
        },
        "enquiry": {
          "body": "お問い合わせ内容",
          "body_default": {
            "rent": "Hello,\n\nI would like to schedule a viewing of this Property for Rent.  Please can you call or email me as soon as possible.\n\nBest Regards.\n",
            "sale": "Hello,\n\nI would like to schedule a viewing of this Property for Sale.  Please can you call or email me as soon as possible.\n\nBest Regards.\n"
          },
          "country_of_residence": "ご住所",
          "email": "Email",
          "name": "お名前",
          "phone": "電話番号"
        },
        "property": {
          "beds": "間取り",
          "price": "価格",
          "property_location": "都道府県",
          "property_type": "物件タイプ"
        }
      },
      "enums": {
        "agent_profile": {
          "edit_languages": {
            "1": "English",
            "1024": "Bahasa Indonesia(インドネシア語)",
            "128": "Português(ポルトガル語)",
            "16": "한국어(韓国語)",
            "2": "简体中文",
            "2048": "日本語",
            "256": "Русский(ロシア語)",
            "32": "Français(フランス語)",
            "4": "繁體中文",
            "4096": "Deutsch(ドイツ語)",
            "512": "Tiếng Việt(ベトナム語)",
            "64": "Español(スペイン語)",
            "8": "ไทย(タイ語)",
            "8192": "Italiano(イタリア語)"
          },
          "languages": {
            "1": "English",
            "1024": "Bahasa Indonesia",
            "128": "Português",
            "16": "한국어",
            "2": "简体中文",
            "2048": "日本語",
            "256": "Русский",
            "32": "Français",
            "4": "繁體中文",
            "4096": "Deutsch",
            "512": "Tiếng Việt",
            "64": "Español",
            "8": "ไทย",
            "8192": "Italiano"
          },
          "locations": {
            "-1": "全国（ALL Area)",
            "1": "北海道",
            "10": "群馬県",
            "11": "埼玉県",
            "12": "千葉県",
            "13": "東京都",
            "14": "神奈川県",
            "15": "新潟県",
            "16": "富山県",
            "17": "石川県",
            "18": "福井県",
            "19": "山梨県",
            "2": "青森県",
            "20": "長野県",
            "21": "岐阜県",
            "22": "静岡県",
            "23": "愛知県",
            "24": "三重県",
            "25": "滋賀県",
            "26": "京都府",
            "27": "大阪府",
            "28": "兵庫県",
            "29": "奈良県",
            "3": "岩手県",
            "30": "和歌山県",
            "31": "鳥取県",
            "32": "島根県",
            "33": "岡山県",
            "34": "広島県",
            "35": "山口県",
            "36": "徳島県",
            "37": "香川県",
            "38": "愛媛県",
            "39": "高知県",
            "4": "宮城県",
            "40": "福岡県",
            "41": "佐賀県",
            "42": "長崎県",
            "43": "熊本県",
            "44": "大分県",
            "45": "宮崎県",
            "46": "鹿児島県",
            "47": "沖縄県",
            "5": "秋田県",
            "6": "山形県",
            "7": "福島県",
            "8": "茨城県",
            "9": "栃木県"
          },
          "prefectures": {
            "-1": "全国（ALL Area)",
            "1": "北海道",
            "10": "群馬県",
            "11": "埼玉県",
            "12": "千葉県",
            "13": "東京都",
            "14": "神奈川県",
            "15": "新潟県",
            "16": "富山県",
            "17": "石川県",
            "18": "福井県",
            "19": "山梨県",
            "2": "青森県",
            "20": "長野県",
            "21": "岐阜県",
            "22": "静岡県",
            "23": "愛知県",
            "24": "三重県",
            "25": "滋賀県",
            "26": "京都府",
            "27": "大阪府",
            "28": "兵庫県",
            "29": "奈良県",
            "3": "岩手県",
            "30": "和歌山県",
            "31": "鳥取県",
            "32": "島根県",
            "33": "岡山県",
            "34": "広島県",
            "35": "山口県",
            "36": "徳島県",
            "37": "香川県",
            "38": "愛媛県",
            "39": "高知県",
            "4": "宮城県",
            "40": "福岡県",
            "41": "佐賀県",
            "42": "長崎県",
            "43": "熊本県",
            "44": "大分県",
            "45": "宮崎県",
            "46": "鹿児島県",
            "47": "沖縄県",
            "5": "秋田県",
            "6": "山形県",
            "7": "福島県",
            "8": "茨城県",
            "9": "栃木県"
          },
          "rent_listing_count": {
            "0": "未掲載",
            "100": "100件掲載",
            "1000": "1000件掲載",
            "1000000000": "無制限",
            "200": "200件掲載",
            "2000": "2000件掲載",
            "25": "25件掲載",
            "300": "300件掲載",
            "3000": "3000件掲載",
            "400": "400件掲載",
            "5": "5件掲載",
            "50": "50件掲載",
            "500": "500件掲載",
            "600": "600件掲載",
            "700": "700件掲載",
            "800": "800件掲載",
            "900": "900件掲載"
          },
          "rent_listing_plan": {
            "1": "掲載課金プラン",
            "2": "成約報酬プラン",
            "3": "お問い合わせ課金プラン"
          },
          "sale_listing_count": {
            "0": "未掲載",
            "100": "100件掲載",
            "1000": "1000件掲載",
            "1000000000": "無制限",
            "200": "200件掲載",
            "2000": "2000件掲載",
            "25": "25件掲載",
            "300": "300件掲載",
            "3000": "3000件掲載",
            "400": "400件掲載",
            "5": "5件掲載",
            "50": "50件掲載",
            "500": "500件掲載",
            "600": "600件掲載",
            "700": "700件掲載",
            "800": "800件掲載",
            "900": "900件掲載"
          },
          "sale_listing_plan": {
            "1": "掲載課金プラン",
            "2": "成約報酬プラン",
            "3": "お問い合わせ課金プラン"
          },
          "services": {
            "1": "売買(For Sale)",
            "16": "司法書士(Judicial Scrivener)",
            "2": "賃貸(For Rent)",
            "4": "不動産管理(Property Management)",
            "8": "リフォーム・リノベーション(Renovation)"
          },
          "sign_up_content": {
            "1": "5件掲載プラン　6ヵ月間無料トライアルキャンペーン",
            "2": "通常掲載申し込み",
            "3": "Japan-Property への物件広告掲載 お申し込み",
            "4": "Japan-Property への企業情報掲載(無料) お申し込み"
          }
        },
        "property": {
          "agent_fee_type": {
            "1": "ヶ月",
            "2": "円"
          },
          "available_from": {
            "1": "即時",
            "2": "相談",
            "3": "期日指定"
          },
          "available_from_period": {
            "1": "上旬",
            "2": "中旬",
            "3": "下旬"
          },
          "bathrooms": {
            "0.0": 0,
            "0.5": 0.5,
            "1.0": 1,
            "1.5": 1.5,
            "2.0": 2,
            "2.5": 2.5,
            "3.0": 3,
            "3.5": 3.5,
            "4.0": "4+"
          },
          "bedrooms": {
            "-1": "STUDIO",
            "1": "1 Bed",
            "101": "Private Room",
            "102": "Shared Room",
            "2": "2 Beds",
            "201": "Whole Building",
            "3": "3 Beds",
            "4": "4 Beds",
            "5": "5 Beds",
            "6": "6+ Beds"
          },
          "city_planning": {
            "1": "市街化区域",
            "2": "市街化調整区域",
            "3": "区域区分が定められていない都市計画区域",
            "4": "都市計画区域外"
          },
          "connecting_road_direction1": {
            "1": "北",
            "2": "北東",
            "3": "東",
            "4": "南東",
            "5": "南",
            "6": "南西",
            "7": "西",
            "8": "北西"
          },
          "connecting_road_direction2": {
            "1": "北",
            "2": "北東",
            "3": "東",
            "4": "南東",
            "5": "南",
            "6": "南西",
            "7": "西",
            "8": "北西"
          },
          "connecting_road_direction3": {
            "1": "北",
            "2": "北東",
            "3": "東",
            "4": "南東",
            "5": "南",
            "6": "南西",
            "7": "西",
            "8": "北西"
          },
          "connecting_road_direction4": {
            "1": "北",
            "2": "北東",
            "3": "東",
            "4": "南東",
            "5": "南",
            "6": "南西",
            "7": "西",
            "8": "北西"
          },
          "connecting_road_kind1": {
            "1": "公道",
            "2": "私道"
          },
          "connecting_road_kind2": {
            "1": "公道",
            "2": "私道"
          },
          "connecting_road_kind3": {
            "1": "公道",
            "2": "私道"
          },
          "connecting_road_kind4": {
            "1": "公道",
            "2": "私道"
          },
          "construction_status": {
            "1": "中古",
            "2": "建築中",
            "3": "新築"
          },
          "deposit_type": {
            "1": "ヶ月",
            "2": "円"
          },
          "features": {
            "building_facilities": [
              "auto_lock",
              "security_camera",
              "delivery_box",
              "elevator",
              "trunk_room",
              "bicycle_parking",
              "motorcycle_parking",
              "laundromat",
              "always_garbage_disposal_allowed",
              "private_security_company",
              "party_room",
              "kids_room",
              "theater_room"
            ],
            "highlights": [
              "top_floor",
              "high_floor",
              "corner_unit",
              "penthouse",
              "multiple_bathrooms",
              "oceanfront",
              "ocean_view",
              "lake_view",
              "city_skyline_view",
              "mount_fuji_view",
              "resort_property",
              "beach_resort_homes",
              "ski_resort_homes",
              "onsen_resort_homes",
              "highland_resort_homes",
              "lake_resort_homes",
              "near_narita_airport",
              "near_haneda_airport",
              "near_kansai_airport",
              "near_new_chitose",
              "near_fukuoka_airport",
              "traditional_japanese_homes",
              "short_term_rental_allowed",
              "full_occupancy",
              "residents_lounge",
              "cafe_lounge",
              "co_working_space",
              "guest_room",
              "swimming_pool",
              "fitness",
              "sauna",
              "hot_spring",
              "concierge_service",
              "solar_power_generation",
              "ev_charging_station",
              "attached_garage",
              "new_seismic_code",
              "seismic_isolation_structure",
              "no_deposit",
              "no_key_money",
              "furniture_and_appliances_included",
              "monthly_stay_available",
              "luxury",
              "office_use_allowed"
            ],
            "internet_tv": [
              "broadband",
              "catv",
              "free_internet_usage",
              "free_catc_usage"
            ],
            "kitchen_appliances": [
              "refrigerator",
              "stove",
              "systemized_kitchen",
              "all_electric",
              "dishwasher",
              "waste_disposal_unit"
            ],
            "legal_restrictions": [
              "architectural_condition_attached",
              "not_rebuildable"
            ],
            "outdoor_features": [
              "balcony",
              "private_garden"
            ],
            "payment_terms": [
              "credit_card_payment_allowed_on_monthly_rent",
              "credit_card_payment_allowed_on_upfront_costs",
              "credit_card_payment_allowed"
            ],
            "property_type_structure": [
              "duplex_apartment",
              "housing_performance_evaluation_report"
            ],
            "room_features": [
              "video_intercom",
              "flooring",
              "air_conditioner",
              "cooling",
              "heating",
              "underfloor_heating",
              "separate_toilet_and_bath",
              "shower",
              "separate_wash_basin",
              "bidet_toilet",
              "bath_reheating_functionality",
              "auto_bath",
              "bathroom_tv",
              "bathroom_dehumidifier",
              "hot_water_supply",
              "loft",
              "lighting_equipment_included",
              "fire_alarm"
            ],
            "storage": [
              "clost",
              "walk_in_closet",
              "shoes_closet",
              "living_room_storage",
              "storage_room"
            ],
            "terms_conditions": [
              "room_sharing_allowed",
              "two_tenants_allowed",
              "male_only",
              "female_only",
              "singles_only",
              "senior_friendly",
              "pets_negotiable",
              "musical_instruments_allowed"
            ]
          },
          "features_only_rent": [
            "no_deposit",
            "no_key_money",
            "furniture_and_appliances_included",
            "monthly_stay_available",
            "luxury",
            "office_use_allowed",
            "private_security_company",
            "free_internet_usage",
            "free_catc_usage",
            "room_sharing_allowed",
            "two_tenants_allowed",
            "male_only",
            "female_only",
            "singles_only",
            "senior_friendly",
            "musical_instruments_allowed",
            "credit_card_payment_allowed_on_monthly_rent",
            "credit_card_payment_allowed_on_upfront_costs",
            "credit_card_payment_allowed"
          ],
          "features_only_sale": [
            "short_term_rental_allowed",
            "full_occupancy",
            "housing_performance_evaluation_report",
            "architectural_condition_attached",
            "not_rebuildable"
          ],
          "guarantee_company": {
            "1": "利用必須",
            "2": "不要",
            "3": "利用可"
          },
          "insurance": {
            "1": "要",
            "2": "不要"
          },
          "key_money_type": {
            "1": "ヶ月",
            "2": "円"
          },
          "land_category": {
            "1": "宅地",
            "10": "山林・その他",
            "11": "雑種地・その他",
            "2": "田",
            "3": "畑",
            "4": "山林",
            "5": "雑種地",
            "6": "その他",
            "7": "宅地・その他",
            "8": "田・その他",
            "9": "畑・その他"
          },
          "land_law_notification": {
            "1": "要",
            "2": "不要",
            "3": "届出中"
          },
          "land_rights": {
            "1": "所有権",
            "2": "借地権",
            "3": "賃借権",
            "4": "転借権",
            "5": "地上権"
          },
          "land_use_zone": {
            "1": "第一種低層住居専用",
            "10": "準工業",
            "11": "工業",
            "12": "工業専用",
            "13": "無指定",
            "14": "田園住居",
            "2": "第二種低層住居専用",
            "3": "第一種中高層住居専用",
            "4": "第二種中高層住居専用",
            "5": "第一種住居",
            "6": "第二種住居",
            "7": "準住居",
            "8": "近隣商業",
            "9": "商業"
          },
          "main_aspect": {
            "1": "北",
            "2": "北東",
            "3": "東",
            "4": "南東",
            "5": "南",
            "6": "南西",
            "7": "西",
            "8": "北西"
          },
          "management": {
            "1": "自主管理",
            "2": "一部委託",
            "3": "全部委託"
          },
          "management_method": {
            "1": "常駐",
            "2": "日勤",
            "3": "巡回",
            "4": "無"
          },
          "other_expense_code_1": {
            "1": "鍵交換費用",
            "10": "その他費用",
            "2": "クリーニング費用",
            "3": "消毒・抗菌・消臭費",
            "5": "保証会社利用料",
            "6": "火災保険料",
            "7": "入居者サポート費",
            "8": "エアコンクリーニング",
            "9": "害虫駆除費"
          },
          "other_expense_code_2": {
            "1": "鍵交換費用",
            "10": "その他費用",
            "2": "クリーニング費用",
            "3": "消毒・抗菌・消臭費",
            "5": "保証会社利用料",
            "6": "火災保険料",
            "7": "入居者サポート費",
            "8": "エアコンクリーニング",
            "9": "害虫駆除費"
          },
          "other_expense_code_3": {
            "1": "鍵交換費用",
            "10": "その他費用",
            "2": "クリーニング費用",
            "3": "消毒・抗菌・消臭費",
            "5": "保証会社利用料",
            "6": "火災保険料",
            "7": "入居者サポート費",
            "8": "エアコンクリーニング",
            "9": "害虫駆除費"
          },
          "other_expense_code_4": {
            "1": "鍵交換費用",
            "10": "その他費用",
            "2": "クリーニング費用",
            "3": "消毒・抗菌・消臭費",
            "5": "保証会社利用料",
            "6": "火災保険料",
            "7": "入居者サポート費",
            "8": "エアコンクリーニング",
            "9": "害虫駆除費"
          },
          "other_expense_code_5": {
            "1": "鍵交換費用",
            "10": "その他費用",
            "2": "クリーニング費用",
            "3": "消毒・抗菌・消臭費",
            "5": "保証会社利用料",
            "6": "火災保険料",
            "7": "入居者サポート費",
            "8": "エアコンクリーニング",
            "9": "害虫駆除費"
          },
          "parking_space_type": {
            "1": "空有",
            "2": "空無",
            "3": "無"
          },
          "prefecture": {
            "1": "北海道",
            "10": "群馬県",
            "11": "埼玉県",
            "12": "千葉県",
            "13": "東京都",
            "14": "神奈川県",
            "15": "新潟県",
            "16": "富山県",
            "17": "石川県",
            "18": "福井県",
            "19": "山梨県",
            "2": "青森県",
            "20": "長野県",
            "21": "岐阜県",
            "22": "静岡県",
            "23": "愛知県",
            "24": "三重県",
            "25": "滋賀県",
            "26": "京都府",
            "27": "大阪府",
            "28": "兵庫県",
            "29": "奈良県",
            "3": "岩手県",
            "30": "和歌山県",
            "31": "鳥取県",
            "32": "島根県",
            "33": "岡山県",
            "34": "広島県",
            "35": "山口県",
            "36": "徳島県",
            "37": "香川県",
            "38": "愛媛県",
            "39": "高知県",
            "4": "宮城県",
            "40": "福岡県",
            "41": "佐賀県",
            "42": "長崎県",
            "43": "熊本県",
            "44": "大分県",
            "45": "宮崎県",
            "46": "鹿児島県",
            "47": "沖縄県",
            "5": "秋田県",
            "6": "山形県",
            "7": "福島県",
            "8": "茨城県",
            "9": "栃木県"
          },
          "property_type": {
            "-1": "すべての物件種別",
            "1": "アパート・マンション",
            "10": "一棟商業ビル",
            "11": "ホテル・旅館",
            "12": "タウンハウス",
            "2": "戸建て",
            "3": "土地",
            "4": "短期滞在",
            "5": "ゲストハウス・シェアハウス",
            "6": "一棟マンション・アパート",
            "7": "事務所",
            "8": "店舗",
            "9": "事務所・店舗"
          },
          "purpose": {
            "purpose_investment": "投資用",
            "purpose_residence": "自住用"
          },
          "renewal_fee_type": {
            "1": "ヶ月",
            "2": "円"
          },
          "rooms": {
            "1": 1,
            "101": "個室",
            "102": "相部屋",
            "2": 2,
            "3": 3,
            "4": 4,
            "5": 5,
            "6": "6+"
          },
          "rooms_layout": {
            "1": "R",
            "2": "K",
            "3": "SK",
            "4": "DK",
            "5": "SDK",
            "6": "LK",
            "7": "SLK",
            "8": "LDK",
            "9": "SLDK"
          },
          "rooms_layout_search": {
            "1-1": "1R",
            "1-2": "1K",
            "2-2": "2K",
            "2-4": "2DK",
            "2-8": "2LDK",
            "3-2": "3K",
            "3-4": "3DK",
            "3-8": "3LDK",
            "4-2": "4K",
            "4-4": "4DK",
            "4-8": "4LDK",
            "5": "4LDK以上"
          },
          "rooms_rent": {
            "101": "個室",
            "102": "相部屋"
          },
          "rooms_sale": {
            "1": 1,
            "2": 2,
            "3": 3,
            "4": 4,
            "5": 5,
            "6": "6+"
          },
          "rooms_shared": {
            "1": 1,
            "2": 2,
            "3": 3,
            "4": 4,
            "5": 5,
            "6": "6+"
          },
          "setback": {
            "1": "有"
          },
          "status": {
            "1": "空室",
            "10": "使用中",
            "2": "居住中",
            "3": "未完成",
            "4": "更地",
            "5": "古屋あり",
            "6": "賃貸中",
            "7": "賃貸中(一部)",
            "8": "賃貸中(全部)",
            "9": "未入居"
          },
          "structure": {
            "1": "木造",
            "10": "ALC",
            "11": "鉄筋ブロック",
            "12": "CFT",
            "13": "木造・その他",
            "14": "RC・その他",
            "15": "SRC・その他",
            "16": "鉄骨造・その他",
            "17": "ブロック・その他",
            "18": "PC・その他",
            "19": "HPC・その他",
            "2": "RC",
            "20": "軽量鉄骨・その他",
            "21": "ALC・その他",
            "22": "鉄筋ブロック・その他",
            "23": "CFT・その他",
            "3": "SRC",
            "4": "鉄骨造",
            "5": "ブロック",
            "6": "PC",
            "7": "HPC",
            "8": "その他",
            "9": "軽量鉄骨"
          },
          "terms_of_lease_type": {
            "1": "期限表示",
            "2": "期間表示"
          },
          "type": {
            "Properties::Rent": "賃貸",
            "Properties::Sale": "売買"
          },
          "type_of_transaction": {
            "1": "売主/貸主",
            "2": "代理",
            "3": "専属専任媒介",
            "4": "専任媒介",
            "5": "一般媒介",
            "6": "仲介",
            "7": "その他"
          }
        }
      }
    },
    "c": {
      "bookmarked_properties": "お気に入り登録物件",
      "buy": "買う",
      "city_ward": "市区町村",
      "featured": "おすすめ物件表示",
      "for_rent": "賃貸物件",
      "for_sale": "売買物件",
      "japan_blog": "ブログ",
      "login": "ログイン",
      "logout": "ログアウト",
      "make_enquiry": "この物件に問い合わせ",
      "max_price": "上限予算 (円)",
      "name": "お名前",
      "no_max_price": "上限なし",
      "no_max_price_short": "上限なし",
      "no_min_price_short": "下限なし",
      "phone": "電話番号",
      "please_write_your_message": "お問い合わせ内容",
      "provided_by": "Listing provided by :<br>%{name}",
      "read_more": "Read More",
      "rent": "借りる",
      "sale": "売り",
      "search": "検索",
      "search_box": {
        "home_type": "物件種別",
        "maximum": "上限",
        "minimum": "下限",
        "price_range": "価格帯"
      },
      "search_by": {
        "fewer_filters": "閉じる",
        "more_filters": "その他検索",
        "please_select_city": "市区郡にチェックをいれてください",
        "please_select_stations": "駅にチェックをいれてください",
        "please_select_train_lines": "沿線にチェックをいれてください",
        "prefecture": "都道府県",
        "properties_count_surfix": "%{content} (%{count})",
        "property_type": "物件タイプ",
        "search_by_city": "エリアから探す",
        "search_by_train_station": "沿線・駅から探す",
        "search_for_homes_by_city": "Serch for homes by city",
        "search_for_property_by_city": "エリアから探す",
        "search_for_property_by_trainline": "沿線・駅から探す",
        "select_stations": "駅を絞り込む"
      },
      "search_for_properties": "物件検索",
      "sign_up": "会員登録",
      "type_of_home": "物件種別",
      "yen": "円"
    },
    "enquiries": {
      "show": {
        "js": {
          "caution": "送信ボタンを押すことで、お客様は、お問い合わせ内容について弊社から電話やメール等で連絡を受けることに同意したものとみなされます。これらの連絡には、自動送信システムが使用される場合があります。あわせて、お客様の情報の取り扱いに関する「<a href='/privacy-policy'>プライバシーポリシー</a>」に同意いただくものとします。",
          "contact_agent": "Contact agent",
          "submit": "送信"
        }
      }
    },
    "properties": {
      "city": {
        "js": {
          "please_select_cities": "市区町村を選択してください",
          "select_prefecture": "都道府県を選択",
          "title": "エリアから探す"
        }
      },
      "index": {
        "js": {
          "cities": "Cities",
          "empty": "指定された条件に合致する物件が見つかりませんでした。",
          "features": "こだわり条件",
          "over_selected": "一度にまとめてお問い合わせできるのは最大5物件までです。お問い合わせ内容をご確認のうえ、送信してください。",
          "relevant_listings": "おすすめ順",
          "sort": "並び替え：",
          "sort_by_gross_yield_higher": "利回りの大きい順",
          "sort_by_home_age_higher": "完成年月の新しい順",
          "sort_by_home_size_higher": "専有面積の大きい順",
          "sort_by_land_size_higher": "土地面積の大きい順",
          "sort_by_price_higher": "価格の高い順",
          "sort_by_price_lower": "価格の安い順",
          "sort_by_purpose": "投資用"
        }
      },
      "map": {
        "js": {
          "cities": "Cities",
          "empty": "指定された条件に合致する物件が見つかりませんでした。",
          "features": "こだわり条件",
          "over_selected": "一度にまとめてお問い合わせできるのは最大5物件までです。お問い合わせ内容をご確認のうえ、送信してください。",
          "relevant_listings": "おすすめ順",
          "sort": "並び替え：",
          "sort_by_gross_yield_higher": "利回りの大きい順",
          "sort_by_home_age_higher": "完成年月の新しい順",
          "sort_by_home_size_higher": "専有面積の大きい順",
          "sort_by_land_size_higher": "土地面積の大きい順",
          "sort_by_price_higher": "価格の高い順",
          "sort_by_price_lower": "価格の安い順",
          "sort_by_purpose": "投資用"
        }
      },
      "train": {
        "js": {
          "please_select_stations": "駅を選択してください",
          "please_select_train_lines": "沿線を選択してください",
          "select_prefecture": "都道府県を選択",
          "select_stations": "駅を選択",
          "title": "沿線・駅から探す"
        }
      }
    },
    "shared": {
      "header": {
        "language": "Language"
      }
    },
    "welcome": {
      "index": {
        "js": {
          "area_guides": "Area Guides",
          "buying_guide": "Buying Guide",
          "catch_copy": "Find your ideal home <br class='u-sp'>in Japan",
          "explore_top_neighborhoods": "Explore Top Neighborhoods",
          "featured_agencies_and_sellers": "Featured Agencies and Sellers",
          "featured_properties_for_rent": "Featured Properties for Rent",
          "featured_properties_for_sale": "Featured Properties for Sale",
          "find_more_agents": "Find More Agents",
          "footer_description": "Japan-property.jp has one of the leading property portal websites in Japan, foreign buyers and investors to find property from the country's top real estate agents and property developers. The site’s search tools empower customers to easily 'move online' becoming the one stop shop to buy, sell or rent real estate.<br>We will fully support you in purchasing real estate made for investment, as well as securing rental properties such as houses or apartments at popular locations in Japan such as Tokyo, Yokohama, Osaka and Kyoto.",
          "loan_guide": "Loan Guide",
          "newest_listings_for_rent": "新着賃貸物件",
          "newest_listings_for_sale": "新着売買物件",
          "renting_guide": "Renting Guide",
          "view_more_properties": "物件一覧を見る"
        }
      }
    }
  }
}